export default class Name {
  private readonly _first: string;
  private readonly _infix: string|null;
  private readonly _last: string;
  constructor({
    first,
    infix,
    last
  }) {
    this._first = first;
    this._infix = infix;
    this._last = last;
  }

  toString() {
      if (this._infix) {
        return `${this._first} ${this._infix} ${this._last}`;
      }
      return `${this._first} ${this._last}`;
  }

  get first(): string {
    return this._first;
  }
}
